
const filtroBusquedaPQState = {
  loading: null,
  tiposAtencion: [],
  tiposAtencion2: [],
  modalNuevaPrestacion: false,
  solicitudEnCurso: false,
  filtros: {
    tipoAtencion: "",
    tipoAtencion2: "",
    tipoAtencion3: [],
    inicioVigenciaPaquete: "",
    vigencia: "",
    codIntervencion: null,
    codPaquetePres: "",
    glosa: "",
  },
  paquetes: [],
  solicitudes: [],
  modalCargarBorrador: false,
  prestacionesSolicitud: [],
  paquetesEnCurso: [],
  idSolicitud: null,
  pageSize: 0,
  totalPage: 0,
};

export default filtroBusquedaPQState;
